import { render, staticRenderFns } from "./Client_Management.vue?vue&type=template&id=2bc100c1&scoped=true&"
import script from "./Client_Management.vue?vue&type=script&lang=js&"
export * from "./Client_Management.vue?vue&type=script&lang=js&"
import style0 from "./Client_Management.vue?vue&type=style&index=0&id=2bc100c1&prod&scoped=true&lang=scss&"
import style1 from "./Client_Management.vue?vue&type=style&index=1&id=2bc100c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc100c1",
  null
  
)

export default component.exports